import CascateList from "../../../../../../common/components/cascate_list";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import DefaultInput from "../../../../../../common/components/default_input";
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";


type Props = {
  nome: string;
  status: number;
  onNome: (v: string) => void;
  onClear: () => void;
  handleStatus: (v: number) => void,
};

export const Header = ({ nome, status, handleStatus, onNome, onClear }: Props) => {
  return (
    <CascateList title="Filtros" defaultOpen>
      <div className="w-full flex flex-col gap-6 items-start justify-center">
        <div className="w-full">
          <DefaultInput 
            label="Pesquisar por Nome" 
            name="search_by_projeto"  
            value={typeof nome === 'string' ? nome : ''}
            onChangeValue={onNome} />
        </div>
        <div className="w-[180px]">
          <FormControl size="small" fullWidth>
            <InputLabel id="select-tempo-label" size="small">Status</InputLabel>
            <Select
              size="small"
              labelId="select-tempo-label"
              label="Condição do Tempo"
              value={status}
              onChange={(event: SelectChangeEvent<number>) => {
                handleStatus(event.target.value as number)
              }}
            >
              <MenuItem value={2}>Todos</MenuItem>
              <MenuItem value={1}>Ativo</MenuItem>
              <MenuItem value={0}>Inativo</MenuItem>
            </Select>
          </FormControl>
        </div>

        <div className="w-full flex justify-end">
          <div className="w-[180px]">
            <PrimaryButton
              startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
              buttonColor="yellow"
              onClick={onClear}
            >
              Limpar filtros
            </PrimaryButton>
          </div>
        </div>
      </div>
    </CascateList>
  );
};
